var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconHome = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-2.167 -1.083)" },
                React.createElement("path", { d: "M7.4,12.8l9.8-7.6l9.8,7.6v11.9c0,1.2-1,2.2-2.2,2.2H9.6c-1.2,0-2.2-1-2.2-2.2V12.8z" }),
                React.createElement("path", { d: "M13.9,26.9V16.1h6.5v10.8" })))));
});
export default IconHome;
//# sourceMappingURL=IconHome.js.map